import React from 'react';
import { Box, Button, Divider } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import { makeStyles } from '@material-ui/styles';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  loginSection: {
    display: 'flex',
    alignItems: 'center',
    '& > .MuiDivider-root': {
      height: 14,
      marginLeft: 8,
      marginRight: 8,
      backgroundColor: theme.palette.text.secondary,
    },
  },
}));

const HeaderLogin = () => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box display="flex" alignItems="center" color="warning.main"></Box>
      <Box className={classes.loginSection}>
        {/*<Link to={'/signin'} className="Cmt-btn" size="small">*/}
        {/*  Login*/}
        {/*</Link>*/}
        {/*<Divider className="Cmt-divider" orientation="vertical" />*/}
        {/* <Link to={'signup-business'} className="Cmt-btn" size="small">
          Register Business
        </Link> */}
      </Box>
    </Box>
  );
};

export default HeaderLogin;
